import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePager(items, perPage = 10) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(items.length / perPage));
  useEffect(() => { if (page > totalPages) setPage(1); }, [items.length, totalPages, page]);
  const pageItems = items.slice((page - 1) * perPage, page * perPage);
  return { page, setPage, totalPages, pageItems, total: items.length, perPage };
}

export function Pager({ pager }) {
  if (pager.total <= pager.perPage) return null;
  return (
    <div className="flex items-center justify-between px-4 py-2.5 border-t border-slate-100 text-xs text-slate-500 bg-white" data-testid="pager">
      <span>Showing {(pager.page - 1) * pager.perPage + 1}–{Math.min(pager.page * pager.perPage, pager.total)} of {pager.total}</span>
      <div className="flex items-center gap-1.5">
        <button onClick={() => pager.setPage(pager.page - 1)} disabled={pager.page <= 1}
                className="p-1.5 rounded border border-slate-200 disabled:opacity-40 hover:bg-slate-50 transition-colors duration-200" data-testid="pager-prev">
          <ChevronLeft size={13} />
        </button>
        <span className="px-1.5 tabular-nums">Page {pager.page} / {pager.totalPages}</span>
        <button onClick={() => pager.setPage(pager.page + 1)} disabled={pager.page >= pager.totalPages}
                className="p-1.5 rounded border border-slate-200 disabled:opacity-40 hover:bg-slate-50 transition-colors duration-200" data-testid="pager-next">
          <ChevronRight size={13} />
        </button>
      </div>
    </div>
  );
}

export function Paged({ items, perPage = 10, children }) {
  const pager = usePager(items, perPage);
  return children(pager.pageItems, <Pager pager={pager} />);
}
